import { useNow } from "@repo/ui/timestamps/timestampContext";

/** Service access counts as ending soon within this long of its end. */
const ENDING_SOON_MS = 15 * 60 * 1000;

/**
 * The milliseconds left until `expiresAt`, as of the shared refreshing "now",
 * or null without one.
 */
export function useServiceAccessMsLeft(expiresAt: string | null) {
  const now = useNow();
  return expiresAt === null ? null : Date.parse(expiresAt) - now.toMillis();
}

/** "5 h 42 min left", rounded down to the minute. */
export function formatServiceAccessTimeLeft(msLeft: number) {
  const totalMinutes = Math.max(0, Math.floor(msLeft / 60_000));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0
    ? `${String(hours)} h ${String(minutes)} min left`
    : `${String(minutes)} min left`;
}

/** Whether service access ends within the next 15 minutes. */
export function checkIsServiceAccessEndingSoon(msLeft: number) {
  return msLeft <= ENDING_SOON_MS;
}
